import { render, staticRenderFns } from "./limitConfig.vue?vue&type=template&id=27211fdf&scoped=true&"
import script from "./limitConfig.vue?vue&type=script&lang=js&"
export * from "./limitConfig.vue?vue&type=script&lang=js&"
import style0 from "./limitConfig.vue?vue&type=style&index=0&id=27211fdf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27211fdf",
  null
  
)

export default component.exports